import React from 'react'
import {withRouter} from 'react-router-dom'
import './changeLang.css';

function ChangeLang(props) {
  let changeLanguage = (text) => {
    // If the user is trying to change from Hebrew to English
    if (window.location.href.includes('/en') && text === "HE") {
        props.history.push(props.location.pathname.slice(3));
    }
    if (!window.location.href.includes('/en') && text === "EN") { // If the user trying to come from English to Hebrew
        props.history.push('/en' + props.location.pathname);
    }
  }
    return (
        <div id="changeLang">
          <div className={!window.location.href.includes('/en') ? "lang active" : "lang"} onClick={(e) => changeLanguage(e.target.innerHTML)}>HE</div>
          <div className={window.location.href.includes('/en') ? "lang active" : "lang"} onClick={(e) => changeLanguage(e.target.innerHTML)}>EN</div>
        </div>
    )
}

export default withRouter(ChangeLang)
